import { makeStyles, Theme } from "@material-ui/core/styles";
export const sidebarWidth = 14;
export const miniSidebarWidth = 4;
const drawerHeaderHeight = 4;
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: `${sidebarWidth}rem`,
    flexShrink: 0,
  },
  open: {
    width: `${sidebarWidth}rem`,
  },
  close: {
    overflowX: "hidden",
    width: `${miniSidebarWidth}rem`,
  },
  sidebar: {
    [theme.breakpoints.up("lg")]: {
      height: `calc(100% - ${drawerHeaderHeight}px)`,
    },
    height: "100%",
    paddingBottom: 30,
  },
  sidebarOpen: {
    flexWrap: "nowrap", //To avoid logo from wrapping when screen is shorter than sidebar
  },
  title: {
    textTransform: "uppercase",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
}));
